import { cn } from "@/utils";
import React from "react";

interface DualColumnProps extends React.HTMLProps<HTMLDivElement> {
  commonColumnsClassName?: string;
  firstColumnClassName?: string;
  lastColumnClassName?: string;
  reverse?: boolean;
  firstColumn: React.ReactNode;
  lastColumn: React.ReactNode;
}

const DualColumn: React.FC<DualColumnProps> = ({
  className,
  commonColumnsClassName = "",
  firstColumnClassName = "",
  lastColumnClassName = "",
  reverse = false,
  firstColumn,
  lastColumn,
  ...props
}) => {
  return (
    <div className={cn("md:flex md:gap-6", reverse && "md:flex-row-reverse", className)} {...props}>
      <div className={cn("md:flex md:w-1/2", commonColumnsClassName, firstColumnClassName)}>
        {firstColumn}
      </div>
      <div className={cn("md:flex md:w-1/2", commonColumnsClassName, lastColumnClassName)}>
        {lastColumn}
      </div>
    </div>
  );
};

export default DualColumn;
